import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const ModalContainer = styled.div`
  width: 460px;
  height: 620px;

  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);

  border-radius: 26px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 25px;
`;

export const Exit = styled.button`
  margin-left: 360px;
  width: 30px;
  height: 30px;
  background-color: white;
  border: 3px solid var(--color-primary);
  border-radius: 50%;

  color: var(--color-primary);
  font-size: 14px;
  font-weight: 700;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
`;

export const ModalTitle = styled.div`
  width: 360px;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 700;
  color: var(--color-primary);
  margin-top: 30px;
`;

export const ModalBody = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const InputBlock = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  margin: 10px;
  font-size: 20px;

  .checkbox-input {
    display: flex;
    text-align: center;
    align-items: center;
    margin: 10px;
    font-size: 20px;
    label {
      margin-left: 6px;
      font-size: 16px;
      cursor: pointer;
    }
  }

  .checkbox-input input[type='checkbox'] {
    appearance: none;
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    background-color: #fff;
    border: 2px solid #c4c4c4;
    border-radius: 2px;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;

    outline: none;

    &::after {
      font-family: 'Font Awesome 5 free';
      content: '\f00c';
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      display: none;
    }

    &:checked {
      background: var(--color-primary);
      border-radius: 3px;
      border: 0;

      &::after {
        display: block;
      }
    }
  }
`;

export const TextArea = styled.textarea`
  margin: 10px;
  padding: 22px;
  width: 350px;
  height: 66px;
  font-size: 16px;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  resize: none;
`;

export const Button = styled.div`
  button {
    margin-top: 20px;
    width: 300px;
    height: 55px;
    border: 0;
    background: #e3ae02;
    border-radius: 5px;

    cursor: pointer;

    color: #fff;
    font-size: 20px;
    font-weight: 700;
  }
`;
